import script from "./LinkToLarge.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkToLarge.vue?vue&type=script&setup=true&lang=js"

import "./LinkToLarge.vue?vue&type=style&index=0&id=80519a06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80519a06"]])

export default __exports__